export default class RegisterMemberModel{
    constructor(
        memberId,
        memberNumber,
        serialNumber,
        firstName,
        surname,
        branch,
        email,
        classId,
        houseNo,
        area,
        village,
        pincode,
        password,
        classificationLevel1,
        classificationLevel2,
        otherClassificationLevel
    ){
        this.memberId = memberId === undefined ? 0 : memberId;
        this.memberNumber = memberNumber === undefined ? 0 : memberNumber;
        this.serialNumber = serialNumber === undefined ? 0 : serialNumber;
        this.firstName = firstName === undefined ? "" : firstName;
        this.surname = surname === undefined ? "" : surname;
        this.branch = branch === undefined ? "" : branch;
        this.email = email === undefined ? "" : email;
        this.classId = classId === undefined ? "" : classId;
        this.houseNo = houseNo === undefined ? "" : houseNo;
        this.area = area === undefined ? "" : area;
        this.village = village === undefined ? "" : village;
        this.pincode = pincode === undefined ? "" : pincode;
        this.password = password === undefined ? "" : password;
        this.classificationLevel1 = classificationLevel1 === undefined ? 0 : classificationLevel1;
        this.classificationLevel2 = classificationLevel2 === undefined ? 0 : classificationLevel2;
        this.otherClassificationLevel = otherClassificationLevel === undefined ? "" : otherClassificationLevel;
    }
}